export const formatCurrency = (value: number | null) => {
  if (value === null) return null;

  return Intl.NumberFormat('en', { currency: 'USD', style: 'currency', maximumFractionDigits: 0 }).format(value);
};

export const formatNumber = (value: number) => {
  if (isNaN(value)) return '0';

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
